import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import ReactPlayer from 'react-player/lazy'
import Loading from "../Loading";
import "./index.css";

function TruApproval() {
    const imgCDNURL = process.env.REACT_APP_CDN_URL + "eaimortgage/images/";
    const PlayBtn = imgCDNURL + "play-btn.svg";
    return (
        <section className="TruApproval-section">
            <Container className="TruApproval-container">
                <Row className="TruApproval-row">
                    <Col lg={6} md={12} sm={12} className="TruApproval-column">
                        <div className="TruApproval-content">
                            <h2 className="TruApproval-heading">The TRU Approval<sup>®</sup> Process</h2>
                            <p className="TruApproval-para">
                                A TRU Approval<sup>®</sup> is more than just your  standard pre-approval from another lender. A TRU Approval<sup>®</sup> means you are  Thoroughly Reviewed and Underwritten for your loan, giving you a big  advantage when it comes to putting in an offer.
                                <br />
                                You'll  know exactly how much home you can afford and an estimate of what your  monthly mortgage payment will be. We'll also be able to address  potential credit issues or other hiccups early in the process so once  you find your dream home, we can close and get you moved in fast.
                            </p>
                            <div className="TruApproval-btn-wrapper">
                                <h3 className="TruApproval-subheading">Get TRU Started Today</h3>
                                <Button variant="warning" className="TruApproval-button" onClick={() => window.open("https://www.swmc.com/ApplyNow/?c=evolution", "_blank")}>Get Started</Button>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={12} sm={12} className="TruApproval-column">
                        <ReactPlayer
                            url='https://www.youtube.com/watch?v=FzQcSC6WgVk'
                            controls={true}
                            light={true}
                            fallback={<Loading />}
                            playIcon={<img src={PlayBtn} alt="Play Button" />}
                            className="tru-approval-player"
                        />
                    </Col>
                            <div className="TruApproval-btn-wrapper-mob">
                                <h3 className="TruApproval-subheading">Get TRU Started Today</h3>
                                <Button variant="warning" className="TruApproval-button" onClick={() => window.open("https://www.swmc.com/ApplyNow/?c=evolution", "_blank")}>Get Started</Button>
                            </div>
                </Row>
            </Container>
        </section>
    );
}
export default TruApproval;